import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from 'src/startup';
import { Providers } from './providers';
import { FullPageSpinner } from './components/Spinner';
import App from './App';
import './index.css';
import 'src/services/i18n/i18n';
import { installChunkErrorListener } from 'src/utils/chunk-error-handler';
import { clearCachesAndReload } from 'src/utils/cache-utils';

// Handle Vite preload failures by clearing stale caches before reloading.
// Without cache clearing, the first reload hits stale assets again, wasting a cycle.
// The void prefix marks intentional fire-and-forget; clearCachesAndReload has an
// internal timeout fallback that guarantees reload even if cache clearing stalls.
const PRELOAD_RELOAD_KEY = 'vite_preload_error_reload';
window.addEventListener('vite:preloadError', (event) => {
  const reloadAttempted = sessionStorage.getItem(PRELOAD_RELOAD_KEY);
  if (!reloadAttempted) {
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, 'true');
    event.preventDefault();
    void clearCachesAndReload();
  } else {
    sessionStorage.removeItem(PRELOAD_RELOAD_KEY);
  }
});
sessionStorage.removeItem(PRELOAD_RELOAD_KEY);

// Install global chunk error listener for dynamic import failures
installChunkErrorListener();

initSentry();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Providers>
      <Suspense fallback={<FullPageSpinner />}>
        <App />
      </Suspense>
    </Providers>
  </React.StrictMode>,
);

